export const toUpperCase = (str) => {
    return str.toUpperCase();
  };


  export const removeCountryCode = (mobileNumber) => {
    // Check if the number starts with '+91'
    if (mobileNumber.startsWith('+91')) {
      return mobileNumber.substring(3); // Remove +91 and return the rest
    }
    // If no +91, return the same number
    return mobileNumber;
  };



  // Method 1: Using toLocaleString() - Recommended
export const formatNumberWithCommas = (number) => {
  // Handle different input types
  const numToFormat = Number(number);
  
  // Check if it's a valid number
  if (isNaN(numToFormat)) return number;
  
  // Use toLocaleString for most reliable comma separation
  return numToFormat.toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};

// Method 2: Using Regex (alternative approach)
export const formatNumberWithCommasRegex = (number) => {
  // Convert to string and split decimal
  const numStr = Number(number).toString();
  const [integer, decimal] = numStr.split('.');
  
  // Add commas to integer part
  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  // Combine with decimal if exists
  return decimal ? `${formattedInteger}.${decimal}` : formattedInteger;
};

// Method 3: Functional approach with reduce
export const formatNumberWithCommasReduce = (number) => {
  const numStr = Number(number).toString();
  const [integer, decimal] = numStr.split('.');
  
  const formattedInteger = integer
    .split('')
    .reverse()
    .reduce((acc, digit, i) => 
      digit + (i && !(i % 3) ? ',' : '') + acc, 
    '');
  
  return decimal 
    ? `${formattedInteger}.${decimal}` 
    : formattedInteger;
};